export function transformDrawingsArrayToObj(data: any[]): any {
  return data.reduce((acc: any, obj: any) => {
    const key = Object.keys(obj)[0] // Get the single key in the object
    acc[key] = obj[key] // Assign the array to the key in the accumulator object
    return acc
  }, {})
}
